export default "__VITE_ASSET__Dkj17yfC__"